import dayjs from 'dayjs'

require('dayjs/locale/ru')
dayjs.locale('ru')

function getMonthDateName(month) {
  const monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря'
  ]
  return monthNames[month]
}

function getMonthName(month) {
  const monthNames = [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь'
  ]
  return monthNames[month]
}

function future(value) {
  let m = dayjs(value)
  const endOfWeek = dayjs()
    .endOf('week')
    .add(1, 'day')
  if (dayjs() > m) {
    // На самом деле - это прошлое
  } else if (dayjs().endOf('day') > m) {
    // Сегодня до конца дня
    return m.format('сегодня в HH:mm')
  } else if (
    dayjs()
      .endOf('day')
      .add(1, 'day') > m
  ) {
    // Завтра до конца дня
    return m.format('завтра в HH:mm')
  } else if (endOfWeek > m) {
    // На этой неделе
    return m.format('dddd в HH:mm')
  } else if (dayjs().endOf('month') > m) {
    // в этом месяце
    return dayjs(value).format('D') + ' ' + getMonthDateName(m.month())
  } else if (dayjs().endOf('year') > m) {
    // в этом году
    return dayjs(value).format('D') + ' ' + getMonthDateName(m.month())
  } else {
    return m.format('DD.MM.YYYY') // Какое-то будущее
  }
}

function past(value) {
  let m = dayjs(value)
  let startOfWeek
  const d = dayjs().startOf('day')
  const day = d.day()
  if (day === 0) {
    startOfWeek = d.subtract(6, 'day')
  } else {
    startOfWeek = d.subtract(day, 'day')
  }

  if (dayjs() < m) {
    // На самом деле - это будущее
  } else if (dayjs().startOf('day') < m) {
    // Сегодня
    return m.format('сегодня в HH:mm')
  } else if (
    dayjs()
      .startOf('day')
      .subtract(1, 'day') < m
  ) {
    // Вчера
    return m.format('вчера в HH:mm')
  } else if (startOfWeek < m) {
    // На этой неделе
    return m.format('dddd в HH:mm')
  } else if (dayjs().startOf('month') < m) {
    // в этом месяце
    return dayjs(value).format('DD') + ' ' + getMonthDateName(m.month())
  } else if (dayjs().startOf('year') < m) {
    // в этом году
    return dayjs(value).format('DD') + ' ' + getMonthDateName(m.month())
  } else {
    return m.format('DD.MM.YYYY') // Какое-то будущее
  }
}

function thousands(value, sep = ' ') {
  if (!value) {
    return '0'
  }
  var parts = value.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep)
  return parts.join('.')
}

function roubles(value) {
  return thousands(value) + ' ₽'
}

export default {
  past,
  future,
  roubles,
  thousands,
  getMonthDateName,
  getMonthName
}
